import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-menuitem-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.filteredButtons.length > 2)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_Button, {
          icon: "fas fa-ellipsis-v",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.toggleMenu
        }, null, 8, ["onClick"]),
        _createVNode(_component_Menu, {
          id: "buttons_menu",
          ref: "buttons_menu",
          model: _ctx.filteredButtons,
          popup: true
        }, {
          item: _withCtx(({item}) => [
            _createVNode("a", {
              class: "p-menuitem-link",
              role: "menuitem",
              tabindex: "0",
              onClick: ($event: any) => (_ctx.clickedButton($event, item))
            }, [
              _createVNode("span", {
                class: ["p-menuitem-icon", item.icon]
              }, null, 2),
              _createVNode("span", _hoisted_1, _toDisplayString(_ctx.$t(item.label)), 1)
            ], 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64))
    : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredButtons, (button, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_Button, {
          key: index,
          icon: button.icon,
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: ($event: any) => (_ctx.clickedButton($event, button)),
          "data-test": 'delete-button-' + index
        }, null, 8, ["icon", "onClick", "data-test"])), [
          [
            _directive_tooltip,
            _ctx.$t(button.label),
            void 0,
            { bottom: true }
          ]
        ])
      }), 128))
}